<div cdk-overlay-origin #trigger class="select-container" [class.select-container--open]="isOpen" [class.select-container--invalid]="isInvalid()">
  <button
    #triggerButton
    type="button"
    class="select-trigger"
    (click)="toggleDropdown($event)"
    (keydown)="onTriggerKeydown($event)"
    (blur)="onTriggerBlur()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-controls]="isOpen ? listboxId : null"
    [attr.aria-label]="triggerAriaLabel"
    [attr.aria-invalid]="isInvalid() || null"
    [disabled]="isDisabled()"
    [class.placeholder-visible]="placeholderVisible"
    (mouseenter)="syncTruncationTitle($event)"
    (focus)="syncTruncationTitle($event)">
    <span class="select-label">{{ selectedLabel }}</span>
    <svg class="select-chevron" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
    </svg>
  </button>
  @if (showClearButton) {
    <button
      type="button"
      class="select-clear"
      (click)="clearSelection($event)"
      aria-label="Clear selection">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  }
  <ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayMinWidth]="originWidth"
    (attach)="onOverlayAttached()"
    (detach)="isOpen = false"
    (backdropClick)="closeDropdown(false)"
    (overlayOutsideClick)="closeDropdown(false)">
    <div class="select-panel">
      @if (searchable()) {
        <div class="select-search">
          <svg class="select-search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <input
            #searchInput
            type="text"
            class="select-search-input"
            role="combobox"
            aria-autocomplete="list"
            aria-expanded="true"
            autocomplete="off"
            [attr.aria-controls]="listboxId"
            [attr.aria-activedescendant]="activeDescendant"
            [attr.aria-label]="searchAriaLabel"
            [placeholder]="searchPlaceholder()"
            [value]="searchValue"
            (input)="onSearchInput($event)"
            (keydown)="onSearchKeyDown($event)" />
          @if (searchTerm.length > 0) {
            <button type="button" class="select-search-clear" (click)="clearSearchAndFocus()" aria-label="Clear search">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          }
        </div>
      }

      <div
        #listbox
        class="select-dropdown"
        [style.max-height]="listMaxHeight()"
        role="listbox"
        [id]="listboxId"
        [attr.tabindex]="searchable() ? null : -1"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-multiselectable]="multi() || null"
        [attr.aria-activedescendant]="searchable() ? null : activeDescendant"
        [attr.aria-busy]="isLoading() || null"
        (keydown)="onListboxKeydown($event)">
        @if (isLoading()) {
          <div class="select-loading" role="presentation">Loading…</div>
        }

        @if (!isLoading() && searchable() && isSearching && currentOptions.length === 0) {
          <div class="select-no-results" role="presentation">No results found</div>
        }

        @if (!isLoading() && currentOptions.length > 0) {
          @for (option of currentOptions; track option; let i = $index) {
            <div
              class="select-option"
              role="option"
              [id]="optionId(i)"
              [class.multi]="multi()"
              [class.highlighted]="i === highlightedIndex"
              [class.keyboard-active]="i === highlightedIndex && keyboardActive"
              [attr.aria-selected]="isSelected(option)"
              (click)="selectOption(option)"
              (mousemove)="onOptionPointer(i)">
              <span class="select-option-label">{{ optionLabel(option) }}</span>
              <svg class="select-option-check" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>
</div>
